var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddSquare2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.794 1.33203H5.20732C2.78065 1.33203 1.33398 2.7787 1.33398 5.20536V10.7854C1.33398 13.2187 2.78065 14.6654 5.20732 14.6654H10.7873C13.214 14.6654 14.6607 13.2187 14.6607 10.792V5.20536C14.6673 2.7787 13.2207 1.33203 10.794 1.33203Z",
    fill: "#636175"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5H8.5V4C8.5 3.72667 8.27333 3.5 8 3.5C7.72667 3.5 7.5 3.72667 7.5 4V7.5H4C3.72667 7.5 3.5 7.72667 3.5 8C3.5 8.27333 3.72667 8.5 4 8.5H7.5V12C7.5 12.2733 7.72667 12.5 8 12.5C8.27333 12.5 8.5 12.2733 8.5 12V8.5H12C12.2733 8.5 12.5 8.27333 12.5 8C12.5 7.72667 12.2733 7.5 12 7.5Z",
    fill: "#636175"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSquare2);
export default __webpack_public_path__ + "static/media/add-square-2.17700c34ca593684e8cc26e58a4722b2.svg";
export { ForwardRef as ReactComponent };